import React, { useState } from 'react';
import 'react-sticky-header/styles.css';

import { Fab } from '@material-ui/core';

import CommentIcon from '@material-ui/icons/Comment';
import Phone from '@material-ui/icons/Phone';

import '../../App.css';
import Footer from '../organisms/Footer';
import ReservationFormDialog from '../organisms/ReservationFormDialog';
import SEO from '../organisms/SEO';
import seoImg from '../../images/carousel/m4.png';
import MobileNavigationHeader from '../organisms/MobileNavigationHeader';
import LayoutHead from '../organisms/LayoutHead';
import LayoutWrapper from './LayoutWrapper';

const MobileLayout = ({ children, isSEO = true }) => {
  const [isReservationFormOpen, setFormOpen] = useState();

  return (
    <>
      {isSEO
    && (
      <SEO
        title="미래줄눈"
        article="미래줄눈은 줄눈 시공 전문 업체 입니다. 줄눈시공 가격에 대해 언제든 문의해주세요, 서울 경기 동부 서부 남부 북부지사가 있습니다. 김포시, 파주시, 고양시, 동두천시, 양주시, 의정부시, 포천시, 남양주시, 구리시, 하남시, 양평군, 가평군, 여주시, 이천시, 광주시, 성남시, 용인시, 안성시, 의왕시, 과천시, 안양시, 서울시, 수원시, 오산시, 평택시, 황서시, 군포시, 광명시, 부천시, 시흥시, 안산시, 인천광역시 줄눈시공은 미래줄눈에 맡겨주세요. 다양한 시공경험을 갖고있습니다. 한국 환경산업기술원으로부터 위해 우려 제품 자가검사를 통과한 안전한 제품으로 국가공인인증을 받은 제품 KC인증에 합격한 줄눈제를 사용하고 있습니다. 줄눈제는 친환경 독일 정품 폴리우레아 아스파틱 줄눈제로 유기화합물, 황변, 백화 현상이 없고, 경화시간이 2시간 내외입니다. 폴리우레아는 식수운반용 파이프 내부코팅제로 사용하는 안전한 제품입니다. 본사 직영 책임 시공제로, 본사 전문 기사가 시공하고 A/S발생시 책임집니다. 성실시공 완벽시공 철저한 A/S를 보장합니다."
        description="미래줄눈은 줄눈 시공 전문 업체 입니다. 줄눈시공 가격에 대해 언제든 문의해주세요, 서울 경기 동부 서부 남부 북부지사가 있습니다. 다양한 시공경험을 갖고있습니다. 한국 환경산업기술원으로부터 위해 우려 제품 자가검사를 통과한 안전한 제품으로 국가공인인증을 받은 제품 KC인증에 합격한 줄눈제를 사용하고 있습니다. 줄눈제는 친환경 독일 정품 폴리우레아 아스파틱 줄눈제로 유기화합물, 황변, 백화 현상이 없고, 경화시간이 2시간 내외입니다. 폴리우레아는 식수운반용 파이프 내부코팅제로 사용하는 안전한 제품입니다. 본사 직영 책임 시공제로, 본사 전문 기사가 시공하고 A/S발생시 책임집니다. 성실시공 완벽시공 철저한 A/S를 보장합니다"
        image={seoImg}
      />
    )}
      <LayoutHead />
      <LayoutWrapper>
        <MobileNavigationHeader />
        {children}
        <Footer />
        <Fab
          color="primary"
          variant="extended"
          style={{
            position: 'fixed', bottom: '10px', left: '10px', zIndex: 10,
          }}
          onClick={() => {
            if (typeof window !== 'undefined') {
              window.open(
                `tel:${process.env.REACT_APP_HP.replace(/-/g, '')}`,
              );
            }
          }}
        >
          <Phone />
                    &nbsp; 무료상담신청
        </Fab>
        <Fab
          color="primary"
          variant="extended"
          style={{
            position: 'fixed', bottom: '10px', right: '10px', zIndex: 10,
          }}
          onClick={() => {
            setFormOpen(true);
          }}
        >
          <CommentIcon />
        </Fab>
        <ReservationFormDialog
          open={isReservationFormOpen}
          onClose={() => {
            setFormOpen(false);
          }}
          onSubmit={() => {
            setFormOpen(false);
          }}
        />

      </LayoutWrapper>
    </>
  );
};

export default MobileLayout;
